<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>Agregar contacto</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <!-- Providers -->
        <template v-if="providers.length>0">
          <div>
            <label class="text-sm opacity-75">Proveedor*</label>
            <v-select :options="providers"
                      :clearable="false"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-model="document.provider" class="mb-4 md:mb-0" name="provider" id="provider"
                      label="businessName"
                      v-validate="'required'"/>
            <span class="text-danger text-sm"
                  v-show="errors.has('provider')">{{ errors.first('provider') }}</span>
          </div>
        </template>
        <template v-else>
          <vs-input label="Proveedor*"
                    v-model="document.provider.businessName"
                    disabled
                    class="w-full" name="address"
                    v-validate="'required'"/>
        </template>

        <!--Name-->
        <vs-input @blur="document.name= trimString(document.name)"
                  label="Nombres*"
                  v-model="document.name"
                  class="w-full mt-5" name="name"
                  v-validate="'required'"/>
        <span class="text-danger text-sm"
              v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <!--Last name-->
        <vs-input @blur="document.lastName= trimString(document.lastName)"
                  label="Apellidos*"
                  v-model="document.lastName"
                  class="w-full mt-5" name="lastName"
                  v-validate="'required'"/>
        <span class="text-danger text-sm"
              v-show="errors.has('lastName')">{{ errors.first('lastName') }}</span>

        <!--Phone-->
        <vs-input @blur="document.phone= trimString(document.phone)"
                  label="Teléfono*"
                  v-model="document.phone"
                  class="w-full mt-5" name="phone"
                  v-validate="'required'"/>
        <span class="text-danger text-sm"
              v-show="errors.has('phone')">{{ errors.first('phone') }}</span>

        <!--Email-->
        <vs-input @blur="document.email= trimString(document.email)"
                  label="Email*"
                  v-model="document.email"
                  class="w-full mt-5" name="email"
                  v-validate="'required|email'"/>
        <span class="text-danger text-sm"
              v-show="errors.has('email')">{{ errors.first('email') }}</span>

        <!-- Kind of deal -->
        <div class="mt-5">
          <label class="text-sm opacity-75">Tipo de trato*</label>
          <v-select
              placeholder="Selecciona"
              v-validate="'required'"
              :options="kindOfDeal"
              :clearable="false"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="document.kindOfDeal" class="mb-4 md:mb-0" name="kindOfDeal" id="kindOfDeal"/>
          <span class="text-danger text-sm"
                v-show="errors.has('kindOfDeal')">{{ errors.first('kindOfDeal') }}</span>
        </div>

        <!-- Type of contact -->
        <div class="mt-5">
          <label class="text-sm opacity-75">Tipo de contacto*</label>
          <v-select
              placeholder="Selecciona"
              v-validate="'required'"
              :options="typeOfContact"
              :clearable="false"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="document.typeOfContact" class="mb-4 md:mb-0"
              name="typeOfContact"
              id="typeOfContact"/>
          <span class="text-danger text-sm"
                v-show="errors.has('typeOfContact')">{{ errors.first('typeOfContact') }}</span>
        </div>
      </div>
    </component>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || progress">Guardar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
      <div v-if="progress" style="margin-top: 1rem; width: 100%">
        <vs-progress indeterminate color="primary"></vs-progress>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import trimString from '../../../mixins/trimString'

import { db, auth, FieldValue } from '@/firebase/firebaseConfig'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    providers: {
      type: Array,
      required: true
    },
    provider: {
      type: Object
    }
  },
  components: {
    VuePerfectScrollbar
  },
  mixins: [trimString],
  data () {
    return {
      document: {
        provider: {}
      },
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      progress: false,
      kindOfDeal: [
        'Sra.',
        'Srta.',
        'Sr.',
        'Ing.',
        'Dr.',
        'Lic.',
        'Sres.'
      ],
      typeOfContact: [
        'Gerente general',
        'Vendedor',
        'Logística',
        'Sistemas',
        'Soporte',
        'Contabilidad',
        'Marketing'
      ]
    }
  },
  watch: {
    isSidebarActive (val) {
      if (val) {
        this.document = {
          provider: {}
        }
        this.$validator.reset()
        if (this.provider) {
          this.document.provider = {
            ...this.provider
          }
        }
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid () {
      return !this.errors.any()
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    /**
     * Save data in firestore
     * @returns {Promise<void>}
     */
    async submitData () {
      try {
        const result = await this.$validator.validateAll()
        if (result) {
          this.progress = true
          // New contact
          let obj = {
            ...this.document,
            state: true
          }
          const doc = await db.collection('providers').doc(this.document.provider.id).collection('contacts').add({
            ...obj,
            uid: auth.currentUser.uid,
            createdAt: FieldValue.serverTimestamp()
          })
          obj.id = doc.id
          this.$emit('closeSidebar')
          this.$emit('add', obj)
          this.$vs.notify({
            color: 'success',
            title: 'Contactos',
            text: 'Contacto creado correctamente.'
          })
        }
      } catch (e) {
        console.log(e)
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error'
        })
      } finally {
        this.progress = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 450px !important;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
